export const FAMILIES_FEATURE = 'families';
export const FAMILIES = '[Families] Families';

export interface StateWithFamilies {
  [FAMILIES_FEATURE]: CustomFamiliesListState;
}

export interface CustomFamiliesListState {
  families?: any[];
}

